export class SelectPlaylistRequest {
    static Message = 'SelectPlaylistRequest';
}

export class SelectPlaylistResponse {
    static Message = 'SelectPlaylistResponse';

    public playlist: string;

    constructor(playlist: string) {
        this.playlist = playlist;
    }
}
